//
// PositionedModel.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./RelativeConstraint";
import "./ResponsiveConstraint";

var PositionedModel = createModule("BIRD::PositionedModel", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        relativeConstraint: 1,
        hidden: 2,
        name: 7,
        width: 7,
        responsiveConstraint: 1,
        height: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default PositionedModel;
